/* eslint import/prefer-default-export: "off" */
import * as React from 'react'
import Button, { IconProps } from '@src/components/common/button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import styles from '../data.grid.styl'
import cx from 'classnames'
import { GridAction } from '../models/grid.props.configurations'

type WithIconProps<T> = T & IconProps

export interface TemplateProps {
  disabled?: boolean
  onClick: (event: any) => void
  title: string
  className?: string
}

export interface MultiSelectActionProps<T> {
  disabled: boolean
  action: GridAction<T>
  title: string
  template?: React.FC<TemplateProps>
  selectedItemsCount: number
  handleAll: (action?: GridAction<T>) => void
  handleSelected: (action?: GridAction<T>) => void
}

interface State {
  anchorEl: Element | ((element: Element) => Element)
}

const DefaultTemplate: React.FC<WithIconProps<TemplateProps>> = ({
  disabled,
  onClick,
  icon,
  title,
  iconType,
  className
}: WithIconProps<TemplateProps>) => (
  <Button
    disabled={disabled}
    onClick={onClick}
    className={cx(styles.multiItemActionButton, className)}
    icon={icon as any}
    iconType={iconType}
    title={title}
  />
)

function MultiSelectAction<T>(props: WithIconProps<MultiSelectActionProps<T>>) {
  const {
    action,
    disabled,
    title,
    selectedItemsCount,
    icon = null,
    template: Template
  } = props

  const [state, setState] = React.useState<State>({
    anchorEl: null
  })

  function handleAll() {
    props.handleAll(action)
  }

  function handleSelected() {
    props.handleSelected(action)
  }

  function onMenu(event) {
    setState({ anchorEl: event.currentTarget })
  }

  function menuClose() {
    setState({ anchorEl: null })
  }

  function onHandleAll() {
    setState({ anchorEl: null })
    handleAll()
  }

  function onHandleSelected() {
    setState({ anchorEl: null })
    handleSelected()
  }

  const { anchorEl } = state
  const templateProps: WithIconProps<TemplateProps> = {
    disabled,
    onClick: onMenu,
    icon,
    title
  }
  return (
    <div className={styles.gridPlugin}>
      {Template ? (
        <Template {...templateProps} />
      ) : (
        <DefaultTemplate {...templateProps} />
      )}
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={menuClose}
      >
        <MenuItem onClick={onHandleAll}>All</MenuItem>
        <MenuItem
          disabled={selectedItemsCount === 0}
          onClick={onHandleSelected}
        >
          Selected(
          {selectedItemsCount})
        </MenuItem>
      </Menu>
    </div>
  )
}

export default MultiSelectAction
